import { gsap } from 'gsap/all'

export class Modal {
  constructor () {
    this.element = document.querySelector('.js-globe-popup')
    this.triggers = [...document.querySelectorAll('.js-point')]
    this.closeButton = this.element.querySelector('.js-close')
    this.layer = document.querySelector('main .js-globe-layer')

    this.content = {
      title: this.element.querySelector('.js-title'),
      text: this.element.querySelector('.js-text'),
      image: this.element.querySelector('.js-image'),
      link: this.element.querySelector('a')
    }

    this.isOpen = false
    this.init()
  }

  open = trigger => {
    document.body.style.overflow = 'hidden'

    this.content.title.innerHTML = trigger.getAttribute('data-title')
    this.content.text.innerHTML = trigger.getAttribute('data-text')
    this.content.image.src = trigger.getAttribute('data-image')
    this.content.link.href = trigger.getAttribute('data-permalink')

    this.isOpen = true
    this.tweenLayer('in')
    this.tweenElement('in')
    this.tweenElements('in')
  }

  tweenElement (mode) {
    gsap.to(this.element, 0.5, {
      ease: 'expo.out',
      x: mode === 'in' ? 0 : '50%',
      opacity: mode === 'in' ? 1 : 0,
      onStart: () => {
        this.element.style.pointerEvents = 'all'
        this.element.style.willChange = 'transform'
      },
      onComplete: () => {
        this.element.style.willChange = 'unset'

        if (mode === 'out') {
          this.isOpen = false
          this.element.style.pointerEvents = 'none'
        }
      }
    })
  }

  tweenElements (mode) {
    const elements = [...this.element.querySelectorAll('.child')]

    if (mode === 'in') {
      gsap.to(elements, 0.5, {
        x: '0%',
        stagger: 0.05,
        ease: 'expo.out',
        onStart: () => {
          gsap.set(elements, { willChange: 'transform' })
        },
        onComplete: () => {
          gsap.set(elements, { willChange: 'unset' })
        }
      })

      gsap.to(elements, 0.3, {
        opacity: 1,
        delay: 0.1,
        stagger: 0.05,
        ease: 'power2.out'
      })
    } else {
      gsap.set(elements, {
        opacity: 0,
        delay: 0.5,
        x: '100%'
      })
    }
  }

  close = () => {
    if (!this.isOpen) { return false }
    document.body.removeAttribute('style')

    this.triggers.forEach(trigger => {
      trigger.classList.remove('is-active')
    })

    this.tweenLayer('out')
    this.tweenElement('out')
    this.tweenElements('out')
  }

  tweenLayer (mode) {
    gsap.to(this.layer, 0.5, {
      opacity: mode === 'in' ? 0.5 : 0,
      ease: 'power4.out',
      onComplete: () => {
        this.layer.style.pointerEvents = mode === 'in' ? 'all' : 'none'
      }
    })
  }

  bindTriggers () {
    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        trigger.classList.add('is-active')
        this.active = index
        this.open(trigger)
      })
    })

    this.closeButton.addEventListener('click', this.close)
    this.layer.addEventListener('click', this.close)

    window.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        this.close()
      }
    })
  }

  init () {
    this.bindTriggers()
  }
}
